/* PWA registration + online/offline event helpers. */
export function registerServiceWorker() {
  if (typeof window === "undefined") return;
  if (!("serviceWorker" in navigator)) return;
  if (process.env.NODE_ENV !== "production" && !window.location.protocol.startsWith("https")) {
    // CRA dev: still try, but ignore errors
  }
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js", { scope: "/" })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.warn("[teebee] SW registration failed", err);
      });
  });
}

export function onOnline(cb) {
  window.addEventListener("online", cb);
  return () => window.removeEventListener("online", cb);
}

export function onOffline(cb) {
  window.addEventListener("offline", cb);
  return () => window.removeEventListener("offline", cb);
}
